import {Avatar} from 'antd'
import {CloseOutlined} from '@ant-design/icons'

export default function TeacherItem({data,onSelect, onClose}) {
    return (
        <div
            onClick={()=>onSelect && onSelect(data)}
            style={{width:200, cursor:onSelect?'pointer':'default'}}
            className="relative flexbox border-radius border pd12">
            <Avatar
                style={{ borderRadius: 22, width: 44, height: 44}}
                src={data.headImg}
            />
            <div className="flex1 mgl12">
                <div className="bold gray-dark fts-14">{data.lecturerName}</div>
                <div className="gray ellipsis mgt6 fts-13">{data.title}</ div>
            </div>
            {!!onClose && <CloseOutlined className="absolute cursor" onClick={()=>onClose(data)}  style={{top: 6, right: 6}}/>}
        </div>
    )
}